import { Event } from "@app/core/tracking/domain/event";
export class CheckoutViewedEvent implements Event {
}